import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useSetupIntents} from '../hooks/useSetupIntents';

/**
 * FNP-918: batch-delete the selected setup intents.
 *
 * ⚠️ `deleteRecords` is called through the list hook, which owns the mutation
 * and invalidates the module query key on success — the table refreshes without
 * a manual reload (§8).
 *
 * `onDeleteComplete` clears the Redux selection. That is required, not
 * cosmetic: selection now survives unmount, so without it the ids of deleted
 * records stay selected and the next confirm targets setup intents that no
 * longer exist.
 */
interface DeleteRecordButtonProps {
    selectedIds: string[];
    onDeleteComplete?: () => void;
}

export const DeleteRecordButton = ({
                                       selectedIds,
                                       onDeleteComplete,
                                   }: DeleteRecordButtonProps) => {

    const {deleteRecords} = useSetupIntents();

    const disabled = selectedIds.length === 0;

    return (
        <DeleteRecordsConfirmationButton
            disabled={disabled}
            recordIdsLength={selectedIds.length}
            handleConfirm={() => {
                deleteRecords(selectedIds);
                onDeleteComplete?.();
            }}
        />
    );
};
